import React, { Component } from 'react';
import LangContainer from './LangContainer';
import PropTypes from 'prop-types';
import { findFlagUrlByIso3Code } from "country-flags-svg";
import GNDFlag  from './../../../../assets/images/honduras.svg';
import GBRFlag  from './../../../../assets/images/flag-gb.svg';

export const flags = {
    HND: GNDFlag,
    GBR: GBRFlag
}

class Switcher extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeLang: null,
            defaultLang: { 
                active: true,
                countryIso3: "UKR",
                id: 1,
                isocode: "uk",
                nameNative: "українська",
                nameUkr: "українська"
            }
        }
    }

    componentDidMount() {
        const activeLang =  localStorage.getItem('activeLang');
        this.setState({activeLang});
    }

    handleActiveLang = (iso) => {
        this.props.setActiveLang(iso);
        localStorage.setItem('activeLang', iso);
        this.setState({activeLang: iso});
        this.props.showLangContainer();
    }

    render() {
        let allLang = [];
        let currentLang = [];
        if (!this.state.activeLang) {
            allLang = this.props.lang.length > 0 ? 
                this.props.lang.filter(lang => lang.isocode !== this.state.defaultLang.isocode) : [];
            currentLang = this.props.lang.length > 0 ? 
                this.props.lang.filter(lang => 
                    lang.isocode === this.state.defaultLang.isocode) : this.state.defaultLang;
        } else {
            allLang = this.props.lang.length > 0 ? 
                this.props.lang.filter(lang => lang.isocode !== this.state.activeLang) : [];
            currentLang = this.props.lang.length > 0 ? 
                this.props.lang.filter(lang => lang.isocode === this.state.activeLang) : this.state.defaultLang;
        }
        let flagUrl = '';
        if (currentLang[0]) {
            flagUrl =  flags[currentLang[0].countryIso3] || findFlagUrlByIso3Code(currentLang[0].countryIso3 );
        }
        const isHideDownIcon = this.props.size === 1 ? 'hide' : '';
        return(
            <div className='lang-select'>
                <div className="selected-lang">
                    <div className='lang-item' id={currentLang[0] ? currentLang[0].isocode : ''}>
                        <img src={flagUrl} alt={currentLang[0] ? currentLang[0].nameNative : ''} referrerPolicy="no-referrer"/>
                        {currentLang[0] ? currentLang[0].nameNative : ''}
                    </div>
                    <span className={`down ${this.props.isShow ? 'show' : ''} ${isHideDownIcon}`} 
                            onClick={this.props.showLangContainer}>
                    </span>
                </div>
                <LangContainer lang={allLang} isShow={this.props.isShow} activeLang={this.handleActiveLang}/>
            </div>
        )
    }
}

export default Switcher;

Switcher.propTypes = {
    lang: PropTypes.array.isRequired,
    setActiveLang: PropTypes.func.isRequired,
    showLangContainer: PropTypes.func.isRequired,
    isShow: PropTypes.bool.isRequired,
    size: PropTypes.number.isRequired,
}